module.exports = __webpack_public_path__ + "db7f3ef9f3244a3acdd00bbc3e7eab04.svg";